import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { sanitize } from "isomorphic-dompurify";
import { Typography } from "../Typography";
import styles from "./LegalText.module.scss";
export const LegalText = ({ legalText, className }) => {
    if (!legalText) {
        return null;
    }
    return (_jsx(Typography, { className: classNames(styles.legalText, className), variant: "body1", weight: "light", children: _jsx("span", { dangerouslySetInnerHTML: { __html: sanitize(legalText, { ADD_ATTR: ["target"] }) } }) }));
};
//# sourceMappingURL=LegalText.js.map